import {
  ChartBarIcon,
  CogIcon,
  RefreshIcon,
} from '@heroicons/react/outline'

import { User } from '../../lib/user'
import { GameStatus } from '../../components/games/Game'
import {
  GameMode,
  GAME_TITLE,
  GAME_MODE_UNLIMITED,
  GAME_MODE_DAILY,
  GAME_MODE_MINI_DAILY,
} from '../../constants/strings'
import { BaseMenu } from '../../components/menu/BaseMenu'

type Props = {
  user: User,
  setIsInfoModalOpen: (value: boolean) => void
  setIsStatsModalOpen: (value: boolean) => void
  setIsSettingsModalOpen: (value: boolean) => void
  setIsSupportModalOpen: (value: boolean) => void
  setIsProfileModalOpen: (value: boolean) => void
  onRefresh: () => void
  onGiveUp: () => void
  gameMode: GameMode
  gameStatus: GameStatus|null
}

export const Navbar = ({
  user,
  setIsInfoModalOpen,
  setIsStatsModalOpen,
  setIsSettingsModalOpen,
  setIsSupportModalOpen,
  setIsProfileModalOpen,
  onRefresh,
  onGiveUp,
  gameMode,
  gameStatus,
}: Props) => {
  const gameModeIndicator = () => {
    if(new Set([GAME_MODE_DAILY, GAME_MODE_MINI_DAILY]).has(gameMode)) {
      const index = gameStatus ? `${gameStatus.solution.index}` : ''
      return <span className="text-sm text-gray-500 dark:text-gray-300 title absolute leading-7 left-2">#{index}</span>

    }
    if(gameMode === GAME_MODE_UNLIMITED) {
      return <span className="text-xl text-gray-500 dark:text-gray-300 absolute leading-7 left-2">∞</span>
    }
    return <></>
  } 

  return (
    <div className="navbar">
      <div className="flex pt-2 items-center justify-center px-3">
        <div className="icon-group flex-1 justify-start">
          <BaseMenu
            user={user}
            setIsSupportModalOpen={setIsSupportModalOpen}
            setIsProfileModalOpen={setIsProfileModalOpen}
            setIsInfoModalOpen={setIsInfoModalOpen}
          />
          {gameMode === GAME_MODE_UNLIMITED && (
            <RefreshIcon
              id="nav-btn-refresh"
              className="h-6 w-6 mr-2 scale-up cursor-pointer dark:stroke-white"
              aria-label="refresh"
              role="button"
              tabIndex={0}
              onClick={onRefresh}
            />
          )}
          {gameStatus && !(gameStatus.isGameWon || gameStatus.isGameLost) &&
          <button className={`transform transition-all ease-in p-1 h-6 text-xs inline-flex justify-center items-center text-center rounded-md border border-orange-400 hover:bg-orange-600 shadow-sm bg-orange-400 font-medium text-white focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 ${gameStatus.guesses.length >= 1 ? 'scale-100' : 'scale-0'}`}
              onClick={onGiveUp} >
        
            Give up
          </button>
          }
        </div>
        <div className="flex flex-1 justify-center items-center">
          <p className="text-xl font-bold title dark:text-white mt-1">
            {GAME_TITLE}
            {user?.hasPolygonlePlus() && "+"}
            <span className="relative w-0 h-0">
              {gameModeIndicator()}
            </span>
          </p>
        </div>
        <div className="icon-group flex-1 justify-end">
          <ChartBarIcon
            id="nav-btn-stats"
            className="h-6 w-6 mr-3 scale-up cursor-pointer dark:stroke-white"
            aria-label="stats"
            role="button"
            tabIndex={0}
            onClick={() => setIsStatsModalOpen(true)}
          />
          <CogIcon
            id="nav-btn-settings"
            className="h-6 w-6 scale-up cursor-pointer dark:stroke-white"
            aria-label="settings"
            role="button"
            tabIndex={0}
            onClick={() => setIsSettingsModalOpen(true)}
          />
        </div>
      </div>
    </div>
  )
}
